<div class="container-fluid">
    <div class="row">
        <div class="col">
            <div class="table-responsive" [ngStyle]="{'height':vh +'px'}">
                <table class="table-default">
                    <thead>
                        <tr>
                            <th class="grid-color">
                                <span class="grid-size marg-10">Grid Name</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="this.gridNames.length>0">
                        <tr class="row-hover" *ngFor="let names of gridNames">
                            <td>
                                <span class="name-size marg-10">{{names.GridName}}</span>
                                <button type="button" class="ct-btn secondary-btn right-almt" (click)="ConfirmDelete(names.BatchId)">
                                    Delete
                                </button>
                                <button type="button" (click)="EditMarginData(names.BatchId)" class="ct-btn primary-btn right-almt">
                                    Edit
                                </button>                                
                            </td>                            
                        </tr>
                    </tbody>
                    <tbody *ngIf="this.gridNames.length===0">
                        <tr>
                            <td style="text-align: center;">
                                <span class="name-size">No records found</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <button type="button" class="ct-btn primary-btn right-almt" (click)="BackToMarginCalculator()" style="margin:5px;">
                    Back
                </button> 
            </div>
        </div>
    </div>
    <div class="spinner-holder" [hidden]="!loading">
        <div class="spinner spinner-border text-primary"></div>
    </div>
</div>
